/**
 * @function truncateWithEllipses Returns a truncated string up to the given characterLength with '...' appended to the end
 * @param {string} text
 * @param {number} characterLength
 */
export const truncateWithEllipses = (text = '', characterLength = 150) =>
  text.length <= characterLength
    ? text
    : `${text.slice(0, characterLength)}...`;
